export default __webpack_public_path__ + "static/media/background-5-1.639702d4.png";